import { Typography } from '@mui/material'

interface ListItemProps {
  label: string
  transform?: (value?: any) => string
  value?: any
  RenderValue?: any
  hide?: boolean
}

export const ListItem = (props: ListItemProps) => {
  const {
    label,
    transform = (value: any) => value,
    value,
    RenderValue,
    hide = false
  } = props

  let normalizedValue = '-'

  if (
    value !== null &&
    value !== undefined &&
    value !== '' &&
    String(value).trim() !== ''
  )
    normalizedValue = transform(value)

  if (hide) return null

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 15 }}>
      <Typography variant="caption" gutterBottom>
        {label}
      </Typography>
      {RenderValue || (
        <Typography style={{ fontSize: 14, fontWeight: 500 }} mb={2}>
          {normalizedValue}
        </Typography>
      )}
    </div>
  )
}
